import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 0;
  padding: 0;
  padding-bottom: 56.25%;

  iframe {
    top: 0;
    bottom: 0;
    left: 0;
    border: 0;
  }
`

Wrapper.displayName = 'Wrapper'
